/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Confirmed_TotalInputs */

const en_case_payment_validation_confirmed_total = /** @type {(inputs: Case_Payment_Validation_Confirmed_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The total cannot be lower than, or differ from, the confirmed payment amounts.`)
};

const pt_br2_case_payment_validation_confirmed_total = /** @type {(inputs: Case_Payment_Validation_Confirmed_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O valor total não pode ser menor nem diferente dos valores de pagamento confirmados.`)
};

/**
* | output |
* | --- |
* | "The total cannot be lower than, or differ from, the confirmed payment amounts." |
*
* @param {Case_Payment_Validation_Confirmed_TotalInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_confirmed_total = /** @type {((inputs?: Case_Payment_Validation_Confirmed_TotalInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Confirmed_TotalInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_confirmed_total(inputs)
	return pt_br2_case_payment_validation_confirmed_total(inputs)
});